import { useRef } from 'react';

// Components
import Modal from '@/components/base/Modal';
import MediaLibraryViewerContent from '@/components/pages/media/MediaLibraryViewer/MediaLibraryViewerContent';
import MediaLibraryViewerNavigation from '@/components/pages/media/MediaLibraryViewer/MediaLibraryViewerNavigation';

const MediaLibraryViewerModal = ({
    open,
    toggleModal,
    navAction,
    mediaNext,
    mediaPrev,
    onDismiss,
    current,
    mutateLibraryMedia,
    deleteSuccess,
    availableTags
}) => {
    const modalRef = useRef();

    return (
        <Modal size="full" open={open} onDismiss={onDismiss} ref={modalRef}>
            <Modal.Body className="w-full">
                {mediaPrev && (
                    <MediaLibraryViewerNavigation
                        media={mediaPrev}
                        isNext={false}
                        navAction={() => {
                            navAction(mediaPrev.id);
                        }}
                        className="btn-mv-nav-prev"
                        modalParent={modalRef}
                    />
                )}
                {current && (
                    <MediaLibraryViewerContent
                        media={current}
                        availableTags={availableTags}
                        mutateLibraryMedia={mutateLibraryMedia}
                        deleteSuccess={deleteSuccess}
                        toggleModal={toggleModal}
                    />
                )}
                {mediaNext && (
                    <MediaLibraryViewerNavigation
                        media={mediaNext}
                        isNext={true}
                        navAction={() => {
                            navAction(mediaNext.id);
                        }}
                        className="btn-mv-nav-next"
                        modalParent={modalRef}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
};

export default MediaLibraryViewerModal;
